import { push } from 'react-router-redux';
import Cookies from 'js-cookie';

import forceLogoutHandler from '../users/a.users.forceLogoutHandler';

import {

} from '../actions.export'

////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////
// Get a specific component
////////////////////////////////////////////////////////////////////////////
////////////////////////////////////////////////////////////////////////////

export const requestGetPublicPublishedComponent = packet => {
  return {
    type: 'REQUEST_GET_PUBLIC_PUBLISHED_COMPONENT',
    data: {
      lastSubmit: packet
    }
  }
}

export const receiveGetPublicPublishedComponentSuccess = data => ({
  type: 'RECEIVE_GET_PUBLIC_PUBLISHED_COMPONENT_SUCCESS',
  data
})

export const receiveGetPublicPublishedComponentFail = data => ({
  type: 'RECEIVE_GET_PUBLIC_PUBLISHED_COMPONENT_FAIL',
  data
})

export const tryToGetPublicPublishedComponent = packet => (dispatch, getState) => {

  dispatch(requestGetPublicPublishedComponent(packet));

  let headers = {
    "Content-Type": "application/json"
  }

  let fs = localStorage.getItem(process.env.REACT_APP_COOKIE_FEATURE_SWITCH);
  if(fs){
    headers["X-NFS"] = fs;
  }


  headers["X-CSRF-TOKEN"] = getState().userReducer.csrf_token;

  return fetch('/api/components/public/' + packet.id + '/' + (packet.version || 'latest'), {
      method: 'get',
      headers: headers
    })
    .then((response) => {
      let json = response.json();
      if (response.status >= 200 && response.status < 300) return json;
      return json.then(Promise.reject.bind(Promise));
    })
    .then(function(json){
      dispatch(receiveGetPublicPublishedComponentSuccess(json));
    })
    .catch(e => {
      dispatch(forceLogoutHandler(e));
      dispatch(receiveGetPublicPublishedComponentFail({errors:e, lastSubmit: packet}));
    })
}
